import React from "react";
import * as moment from "moment";
import NumberFormat from "react-number-format";
import {
  ActionTableButton,
  DownloadIconButton,
  InfoTableButton,
} from "../../../../../../library/button";

const Index = ({ receipt, index, arr }) => {
  const formatted_date = (timestamp) => {
    return moment(timestamp * 1000).format("HH:MM DD/MM/YYYY");
  };

  const format_status = (role) => {
    switch (role) {
      case "paid":
        return "Betalt";
      default:
        return "Ikke betalt";
    }
  };

  return (
    <tr className={index === arr.length - 1 && "last"}>
      <td>
        <span className="date">
          {receipt && formatted_date(receipt.created)}
        </span>
      </td>
      <td>Leadfind Abonnement</td>
      <td>
        <span className="amount-display">
          <NumberFormat
            displayType={"text"}
            thousandSeparator={" "}
            value={receipt.subtotal / 100}
          />
          kr
        </span>
      </td>
      <td className="download">
        <a href={receipt.invoice_pdf}>
          <ActionTableButton color="gray" title="Last ned faktura" />
        </a>
      </td>
    </tr>
  );
};

export default Index;
